import { FC } from 'react';

import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
interface MainCardWithHeaderProps {
    heading: string;
}

export const MainCardWithHeader: FC<MainCardWithHeaderProps> = ({ heading, children }) => {
    const styles = useTheme();

    return (
        <Box
            borderRadius="16px"
            border={`1px solid ${styles.palette.orange.main}`}
            overflow="hidden"
            flex={1}
            boxShadow="0px 4px 20px rgba(38, 50, 56, 0.1)"
        >
            <Box bgcolor={styles.palette.orange.main} paddingY="14px">
                <Typography textAlign="center" color="#FFFCF0" fontSize="24px" lineHeight="34px">
                    {heading}
                </Typography>
            </Box>
            <Box p={3}>{children}</Box>
        </Box>
    );
};
